import {readingFontSizes, readingFontStyles, themes} from '../theme/themes';

export const STORAGE_LANGUAGE = 'STORAGE_LANGUAGE';
export const HELLO = 'HELLO';

// DATABASE
export const INTEGER = 'INTEGER';
export const TEXT = 'TEXT';
export const REAL = 'REAL';
// Version
export const COMMENT = 'COMMENT';
export const CREATED_AT = 'CREATED_AT';
export const UPDATED_AT = 'UPDATED_AT';
// User / auth (local DB + future Supabase profile sync)
export const userId = 'userId';
export const userEmail = 'userEmail';
export const displayName = 'displayName';
export const avatarUrl = 'avatarUrl';
export const remoteUserId = 'remoteUserId';
export const settingsJson = 'settingsJson';
// Book
export const title = 'title';
export const label = 'label';
export const sequence = 'sequence';
export const testament = 'testament';
export const translated = 'translated';
export const additionalBook = 'additionalBook';
export const audioBookName = 'audioBookName';
export const audioChapterId = 'audioChapterId';
// Chapter
export const chapterId = 'chapterId';
export const book_title = 'book_title';
export const isIntroBook = 'isIntroBook';
export const content = 'content';
export const positionInBook = 'positionInBook';
export const audioDownloaded = 'audioDownloaded';
export const book_title_idx = 'book_title_idx';
// Verse
export const id = 'id';
export const canon_order = 'canon_order';
export const chapter = 'chapter';
export const verse_number = 'verse_number';
export const verse_txt = 'verse_txt';
export const start_time = 'start_time';
export const end_time = 'end_time';
export const similarity = 'similarity';
// Footnotes
export const keyword = 'keyword';
export const ref = 'ref';
// Notes
export const chapter_chapterId = 'chapter_chapterId';
export const note = 'note';
export const position = 'position';
export const timestamp = 'timestamp';
export const verseRange = 'verseRange';
// FavoriteQuite
export const quote = 'quote';
// Reading plan
export const readingPlanId = 'readingPlanId';
export const readingName = 'readingName';
export const readingPlanAliasName = 'readingPlanAliasName';
export const readingActive = 'readingActive';
// ReadingPlanProgress
export const readingId = 'readingId';
export const readingEntryId = 'readingEntryId';
export const readingContent = 'readingContent';
export const readingSequence = 'readingSequence';
export const readingCompleted = 'readingCompleted';
export const readingCompletedTimestamp = 'readingCompletedTimestamp';
export const readingEntryCompleted = 'readingEntryCompleted';
export const readingCompensation = 'readingCompensation';
export const readingDateLabel = 'readingDateLabel';
export const fk_reading_plan = 'fk_reading_plan';
// IntroductionSentences
export const sentenceId = 'sentenceId';
// Meta fields
export const chapterData = 'chapterData';
// Testament
export const OLD_TESTAMENT_CODE = 0;
export const NEW_TESTAMENT_CODE = 1;
export const ALL_TESTAMENT_CODE = -1;
// Last reading
export const LAST_READING_CHAPTER = 'LAST_READING_CHAPTER';
export const DEFAULT_LAST_READING_CHAPTER = '1000';
// Bookmarked reading
export const BOOKMARK_CHAPTER = 'BOOKMARK_CHAPTER';
// Listening events
export const track = 'track';
export const url = 'url';
export const index = 'index';
// Last listening
export const LAST_LISTENING = 'LAST_LISTENING';
export const LAST_LISTENING_POSITION = 'LAST_LISTENING_POSITION';
export const THEME_SETTINGS = 'THEME_SETTINGS';
export const THEME_FONTS = 'THEME_FONTS';
export const THEME_MODE = 'THEME_MODE';
export const THEME_SIZE = 'THEME_SIZE';
export const DEFAULT_THEME_SETTINGS = {
  [THEME_FONTS]: readingFontStyles.serif,
  [THEME_MODE]: themes.light.name,
  [THEME_SIZE]: readingFontSizes.normal,
};
// Active reading plan
export const ACTIVE_READING_PLAN = 'ACTIVE_READING_PLAN';
// First-launch auth prompt (AsyncStorage: dismissed = '1')
export const AUTH_PROMPT_DISMISSED = 'AUTH_PROMPT_DISMISSED';
// Verse of the day (local notifications; AsyncStorage)
export const VERSE_OF_DAY_ENABLED = 'VERSE_OF_DAY_ENABLED';
export const VERSE_OF_DAY_HOUR = 'VERSE_OF_DAY_HOUR';
export const VERSE_OF_DAY_MINUTE = 'VERSE_OF_DAY_MINUTE';
/** AsyncStorage key: pending verse id after verse-of-day notification press (cold start). */
export const PENDING_VERSE_OF_DAY_NAV = 'PENDING_VERSE_OF_DAY_NAV';
/** Notifee notification `data.type` for verse-of-day notifications. */
export const VERSE_OF_DAY_NOTIF_DATA_TYPE = 'verse-of-day';

//export const AUDIO_PARENT_LINK = 'https://biblija.duckdns.org/media';
export const AUDIO_PARENT_LINK = 'https://biblija.live/media';
//export const AUDIO_PARENT_LINK = 'https://plavileptir.hr/media';

// App versions
export const APP_VERSION = '6.0.0';
